import { Appointment } from "../../../api/appointment.types";
import { AppointmentsByPhoneAction } from "./appointments.byphone.types";

export const appointmentsByPhoneRequestAction = (params: { medic_user_id: number }): AppointmentsByPhoneAction => ({ type: 'APPOINTMENTS_BY_PHONE_REQUEST', params })

export const appointmentsByPhoneSuccessAction = (appointments: Appointment[]): AppointmentsByPhoneAction => ({ type: 'APPOINTMENTS_BY_PHONE_SUCCESS', params: appointments })

export const appointmentsByPhoneFailureAction = (error?: any): AppointmentsByPhoneAction => ({ type: 'APPOINTMENTS_BY_PHONE_FAILURE' })